import { render, staticRenderFns } from "./FlagIconCustom.vue?vue&type=template&id=adf229ae"
import script from "./FlagIconCustom.vue?vue&type=script&lang=js"
export * from "./FlagIconCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports